import TAnnouncementsEdit from './index.vue';

TAnnouncementsEdit.install = app => {
  app.component(TAnnouncementsEdit.name, TAnnouncementsEdit);
};

export default TAnnouncementsEdit;
